import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CronTime } from 'cron-time-generator';
import { isArray, isNumber } from 'lodash';
import { filter } from 'rxjs/operators';
import { DayOfWeek } from 'src/app/ads/model/day-of-week';
import { getHour, getMinutes, getMonthDays, getWeekDays, isDaily, isMonthly, isWeakly } from '../../util/cron-util';

@Component({
  selector: 'app-cron-generator',
  templateUrl: './cron-generator.component.html',
  styleUrls: ['./cron-generator.component.scss']
})
export class CronGeneratorComponent implements OnInit {

  @Output()
  cronGenerated = new EventEmitter<string | null>();

  @Output()
  cronVaildated = new EventEmitter<boolean>();

  formFiled = FormFields;
  states = State;
  dayOfWeek = DayOfWeek;
  days: any[] = Object.keys(DayOfWeek).slice(0, 7);
  daysOfMonth: number[] = Array.from(Array(31).keys());
  state: State | null = null;
  validateForm: boolean;

  isEqual = (a: any, b: any): boolean => a == b;
  isEqualWeek = (a: any, b: any): boolean => a == DayOfWeek[b];

  form: FormGroup = new FormGroup({
    [FormFields.HOUR]: new FormControl(0, [Validators.required]),
    [FormFields.MINUTE]: new FormControl(0, [Validators.required]),
    [FormFields.DAY_OF_WEEK]: new FormControl([], [Validators.required, Validators.minLength(1)]),
    [FormFields.DAY_OF_MONTH]: new FormControl([], [Validators.required, Validators.minLength(1)])
  });

  ngOnInit(): void {
    this.form.valueChanges
      .pipe(
        filter(() => this.validateForm)
      )
      .subscribe(() => this.onSubmit());
  }

  setState(state: State): void {
    this.cronGenerated.next(null);
    this.cronVaildated.next(false);
    this.setFormGroup(state);
    this.state = state;
  }

  private setFormGroup(state: State): void {
    this.validateForm = false;
    if (state === State.DAILY) {
      this.form.controls[FormFields.DAY_OF_WEEK].clearValidators();
      this.form.controls[FormFields.DAY_OF_MONTH].clearValidators();
      this.form.controls[FormFields.DAY_OF_WEEK].patchValue([]);
      this.form.controls[FormFields.DAY_OF_MONTH].patchValue([]);
    } else if (state === State.WEEKLY) {
      this.form.controls[FormFields.DAY_OF_WEEK].setValidators([Validators.required, Validators.minLength(1)]);
      this.form.controls[FormFields.DAY_OF_MONTH].clearValidators();
      this.form.controls[FormFields.DAY_OF_MONTH].patchValue([]);
    } else if (state === State.MONTHLY) {
      this.form.controls[FormFields.DAY_OF_MONTH].setValidators([Validators.required, Validators.minLength(1)]);
      this.form.controls[FormFields.DAY_OF_WEEK].clearValidators();
      this.form.controls[FormFields.DAY_OF_WEEK].patchValue([]);
    }
    this.validateForm = true;
  }

  private generateCron(state: State): string {
    let cron = null;
    if (state === State.DAILY)
      cron = CronTime.everyDayAt(this.getFormValue(FormFields.HOUR), this.getFormValue(FormFields.MINUTE));
    else if (state === State.WEEKLY)
      cron = CronTime.onSpecificDaysAt(this.getFormValue(FormFields.DAY_OF_WEEK), this.getFormValue(FormFields.HOUR), this.getFormValue(FormFields.MINUTE));
    else if (state === State.MONTHLY)
      cron = CronTime.everyMonthOn(this.getFormValue(FormFields.DAY_OF_MONTH), this.getFormValue(FormFields.HOUR), this.getFormValue(FormFields.MINUTE));

    return cron != null ? '0 ' + cron : null;
  }

  getFormValue(filedName: string): any {
    return this.form.controls[filedName].value;
  }

  onSubmit(): void {
    this.cronVaildated.next(this.form.valid);
    if (this.form.valid) {
      const cronValue = this.generateCron(this.state);
      this.cronGenerated.next(cronValue);
    }
  }


  assaign(cron: string): void {
    if (isDaily(cron)) {
      this.setState(State.DAILY);
      this.validateForm = false;
      this.patchHours(cron);
      this.patchMinutes(cron);
      this.form.controls[FormFields.DAY_OF_WEEK].patchValue([]);
      this.form.controls[FormFields.DAY_OF_MONTH].patchValue([]);
      this.validateForm = true;
      this.cronVaildated.next(true);
    } else if (isWeakly(cron)) {
      this.setState(State.WEEKLY);
      this.validateForm = false;
      this.patchHours(cron);
      this.patchMinutes(cron);
      if (isArray(getWeekDays(cron))) {
        this.form.controls[FormFields.DAY_OF_WEEK].patchValue(getWeekDays(cron));
      } else
        this.form.controls[FormFields.DAY_OF_WEEK].patchValue([]);
      this.form.controls[FormFields.DAY_OF_MONTH].patchValue([]);
      this.validateForm = true;
      this.cronVaildated.next(true);
    } else if (isMonthly(cron)) {
      this.setState(State.MONTHLY);
      this.validateForm = false;
      this.patchHours(cron);
      this.patchMinutes(cron);
      this.form.controls[FormFields.DAY_OF_WEEK].patchValue([]);
      if (isArray(getMonthDays(cron))) {
        this.form.controls[FormFields.DAY_OF_MONTH].patchValue(getMonthDays(cron));
      } else
        this.form.controls[FormFields.DAY_OF_MONTH].patchValue([]);
      this.validateForm = true;
      this.cronVaildated.next(true);
    }
  }

  private patchHours(cron: string): void {
    if (isNumber(getHour(cron)))
      this.form.controls[FormFields.HOUR].patchValue(getHour(cron));
    else
      this.form.controls[FormFields.HOUR].patchValue(0);
  }

  private patchMinutes(cron: string): void {
    if (isNumber(getMinutes(cron)))
      this.form.controls[FormFields.MINUTE].patchValue(getMinutes(cron));
    else
      this.form.controls[FormFields.MINUTE].patchValue(0);
  }

}

enum FormFields {
  HOUR = 'hour',
  MINUTE = 'minute',
  DAY_OF_WEEK = 'dayOfWeek',
  DAY_OF_MONTH = 'daysOfMonth'
}

enum State {
  DAILY, WEEKLY, MONTHLY
}
